import axios from "axios";

export const state = {
    schoolevents: [],
};

export const getters = {
    schoolevents: state => state.schoolevents,
};

export const mutations = {
    setEvent(state, newValue) {
        state.schoolevents = newValue
    },
};

export const actions = {
    fetchSchoolEvents({ commit }) {
        axios.get('/schoolevents').then(res => {
            commit('setEvent', res.data.schoolevents);
        })
    },
};
